import React from 'react';
import './form.css'; // Import your CSS file

const ProfileCard = () => {
  // Hardcoded values
  const data = {
    name: "John Doe",
    email: "john.doe@example.com",
    address: "123 Main St, Springfield",
    role: "Mathematics Teacher",
    info: "Passionate about teaching mathematics and inspiring students.",
  };

  return (
    <div className="profile-container">
    <div className="profile-header">
      <img
        src="https://via.placeholder.com/100"
        alt="Profile"
        className="profile-picture"
      />
      <div className="profile-info-detail">
        <h1 className="profile-name">{data.name}</h1>
        <p className="profile-email">{data.email}</p>
      </div>
    </div>
    <div className="profile-details">
      <div className="profile-info-detail">
        <div className="profile-detail-item">
          <span className="profile-label">Name:</span>
          <span className="profile-value">{data.name}</span>
        </div>
        <div className="profile-info-detail">
          <span className="profile-label">Address:</span>
          <span className="profile-value">{data.address}</span>
        </div>
      </div>
      <div className="profile-detail">
        <div className="profile-info-detail">
          <span className="profile-label">Role:</span>
          <span className="profile-value">{data.role}</span>
        </div>
        <div className="profile-info-detail">
          <span className="profile-label">Email:</span>
          <span className="profile-value">{data.email}</span>
        </div>
      </div>
      <div className="profile-info-detail">
        <span className="profile-label">Info:</span>
        <span className="profile-value">{data.info}</span>
      </div>
    </div>
  </div>
  );
};

export default ProfileCard;
